<template>
  <page-view>
    <div :style="{ marginBottom: '10px' }">
      <demo-video-alert name="SheBeiGuanLi"></demo-video-alert>
    </div>

    <!-- 各个状态机器人的数量 -->
    <a-card style="margin-bottom: 10px; height: 80px; font-size: 16px;">
      <a-row type="flex">
        <a-col :span="4">
          <div class="robitStatusClass">
            <span style="font-size: 14px;">全部机器人</span><br>
            <span style="font-weight: bold;">{{ allRobot }}</span>
          </div>
        </a-col>
        <a-col :span="4">
          <div class="robitStatusClass">
            <span style="font-size: 14px;">软件在线</span><br>
            <span style="font-weight: bold;color: #08f72f;">{{ onLine_robot }}</span>
          </div>
        </a-col>
        <a-col :span="4">
          <div class="robitStatusClass">
            <span style="font-size: 14px;">微信离线</span><br>
            <span style="font-weight: bold;color: red;">{{ wx_offLine_robot }}</span>
          </div>
        </a-col>
        <a-col :span="4">
          <div class="robitStatusClass">
            <span style="font-size: 14px;">软件离线</span><br>
            <span style="font-weight: bold;color: red;">{{ offLine_robot }}</span>
          </div>
        </a-col>
        <a-col :span="4">
          <div class="robitStatusClass">
            <span style="font-size: 14px;">需要续费</span><br>
            <a style="font-weight: bold;">{{ need_renew }}</a>
          </div>
        </a-col>
        <a-col :span="4">
          <div class="robitStatusClass">
            <span style="font-size: 14px;">需要更新</span><br>
            <a style="font-weight: bold;">{{ need_update_robot }}</a>
          </div>
        </a-col>
      </a-row>
    </a-card>

    <a-card :bordered="false">
      <!-- 查询 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item label="查询条件">
                <a-select v-model="queryParam.type" placeholder="请选择查询条件" allowClear>
                  <a-select-option value="1">客户端ID</a-select-option>
                  <a-select-option value="2">微信ID</a-select-option>
                  <a-select-option value="3">微信昵称</a-select-option>
                  <a-select-option value="6">备注</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="查询内容">
                <a-input v-model="queryParam.keywords" placeholder="请输入查询内容" />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="分组">
                <a-select v-model="queryParam.group_id" placeholder="请选择分组" allowClear>
                  <template v-for="(item, index) in groupDataSource">
                    <a-select-option :value="item.id">{{ item.group_name }}</a-select-option>
                  </template>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="状态查询">
                <a-select v-model="queryParam.robot_status" placeholder="请选择查询条件" allowClear>
                  <a-select-option v-for="(item, index) in robitStatusList" :key="index" :value="item.value">
                    {{ item.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <span>
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operator">
        <a-button type="primary" @click="$refs.groupModal.show()">分组管理</a-button>
        <a-dropdown>
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="handleSetDeviceGroup">设置分组</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px" :disabled="!(selectedRowKeys.length > 0)">
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>

      <!-- 列表 -->
      <s-table ref="table" size="default" rowKey="id" :columns="columns" :data="loadData" :alert="options.alert"
        :rowSelection="options.rowSelection" :scroll="{ x: 1450 }">
        <span slot="id" slot-scope="text, record, index">
          <span>{{ record.id }}</span>
          <br>
          <a v-if="record.sub_remark">{{ record.sub_remark }}</a>
          <a v-else @click="addRemark(record)">添加备注</a>
        </span>
        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="avatar" slot-scope="text, record">
          <a-avatar shape="square" icon="user" :src="record.wx_avatar" />
        </span>
        <span slot="nickname" slot-scope="text, record">
          昵称:
          <a v-if="!text.nickname">未设置</a>
          <span v-else :class="{ black: record.del == '2' }">
            {{ text.nickname }}
          </span>
          <span>
            ID: {{ record.wx_id }}
          </span>
        </span>
        <!-- <span slot="ip" slot-scope="text, record">
          <a-tooltip placement="top" v-if="!record.ip">
            <template slot="title">
              <span>请更新机器人客户端到最新版本，或重启后刷新查看</span>
            </template>
          {{'暂无'}}
          </a-tooltip>
          <span>{{ record.ip}}</span>
        </span> -->

        <span slot="port" slot-scope="text, record">
          端口:
          <a-tooltip placement="top" v-if="!record.port">
            <template slot="title">
              <span>请更新机器人客户端到最新版本，或重启后刷新查看</span>
            </template>
            {{ '暂无' }}
          </a-tooltip>
          <span v-else>{{ record.port }}</span>
          <span>
            IP:
            <a-tooltip placement="top" v-if="!record.ip">
              <template slot="title">
                <span>请更新机器人客户端到最新版本，或重启后刷新查看</span>
              </template>
              {{ '暂无' }}
            </a-tooltip>
            <span>{{ record.ip }}</span>
          </span>
        </span>
        <span slot="wx_id" slot-scope="text, record">
          {{ record.wx_id }}
        </span>
        <span slot="db_status" slot-scope="text, record">
          <a-badge v-if="!record.web_sub_database_info" status="error" text="未设置" />
          <a-badge v-else status="processing" text="已设置" />
        </span>
        <span slot="status" slot-scope="text, record">
          <a-badge :status="record.time | statusTypeFilter" :text="record.time | statusFilter" />
        </span>
        <span slot="group_name" slot-scope="text, record">
          {{ record.get_robot_group_list ? record.get_robot_group_list.group_name : '未分组' }}
        </span>
        <span slot="is_online" slot-scope="text, record">
          {{ record.is_online == 1 ? '在线' : '离线' }}
        </span>
        <span slot="time" slot-scope="text, record">
          <span>{{ (text * 1000) | moment }}</span>
        </span>
        <span slot="credit" slot-scope="text, record">
          <span>{{ record.credit | currency('￥') }}</span>
        </span>
        <span slot="action" slot-scope="record">
          <template>
            <a @click="addRemark(record)">修改备注</a>
            <a-divider type="vertical" />
            <a-dropdown>
              <a-menu slot="overlay">
                <a-menu-item @click="handleSettingItem(record.id)">配置</a-menu-item>
                <!-- <a-menu-item @click="$refs.warrantModal.show(record.id)">多号互通</a-menu-item> -->
                <!-- <a-menu-item @click="handleRecharge(record.id)" v-if="!is_customized">充值</a-menu-item> -->
                <a-menu-item :disabled="true" @click="handleRenewal(record.id)">续期</a-menu-item>
                <a-menu-item @click="handleDeleteItem(record.id)">删除</a-menu-item>
              </a-menu>
              <a>
                操作
                <a-icon type="down" />
              </a>
            </a-dropdown>
            <a-divider type="vertical" />
            <a-dropdown>
              <a-menu slot="overlay">
                <!-- <a-menu-item v-if="is_database" @click="handleDatabase(record.id)">数据库设置</a-menu-item> -->
                <!-- <a-menu-item @click="handleDbImport(record.id)">旧数据导入</a-menu-item> -->
                <a-menu-item @click="handleDbInit(record.id)" :disabled="record.web_sub_database_info">创建数据库</a-menu-item>
                <a-menu-item @click="handleDataTransfer(record)">数据迁移</a-menu-item>
              </a-menu>
              <a>
                数据管理
                <a-icon type="down" />
              </a>
            </a-dropdown>
          </template>
        </span>
      </s-table>

    </a-card>

    <renewal-modal ref="renewalModal" @ok="$refs.table.refresh()"></renewal-modal>
    <recharge-modal ref="rechargeModal" @ok="$refs.table.refresh()"></recharge-modal>
    <pay-modal ref="payModal" @ok="$refs.table.refresh()"></pay-modal>
    <database-modal ref="databaseModal"></database-modal>
    <db-import-modal ref="dbImportModal"></db-import-modal>
    <db-init-modal ref="dbInitModal"></db-init-modal>
    <db-init-modal-super ref="dbInitModalSuper"></db-init-modal-super>
    <data-transfer-modal ref="dataTransfer"></data-transfer-modal>
    <delete-modal ref="deleteModal" @ok="$refs.table.refresh()"></delete-modal>
    <warrant-modal ref="warrantModal" @ok="$refs.table.refresh()"></warrant-modal>
    <group-modal ref="groupModal"></group-modal>
    <set-device-group-modal ref="setDeviceGroupModal" @ok="$refs.table.refresh()"></set-device-group-modal>
    <key-input ref="keyInput" @refresh="refresh"></key-input>
  </page-view>
</template>

<script>
import { STable } from '@/components'
import RenewalModal from './modules/RenewalModal'
import RechargeModal from './modules/RechargeModal'
import GroupModal from './modules/GroupModal'
import PayModal from './modules/PayModal'
import DatabaseModal from './modules/DatabaseModal'
import DataTransferModal from './modules/DataTransferModal'
import DbImportModal from './modules/DbImportModal'
import DbInitModal from './modules/DbInitModal'
import DbInitModalSuper from './modules/DbInitModalSuper'
import DeleteModal from './modules/DeleteModal'
import WarrantModal from './modules/WarrantModal'
import SetDeviceGroupModal from './modules/SetDeviceGroupModal'
import DemoVideoAlert from '@/views/components/DemoVideoAlert'
import KeyInput from './modules/KeyInput'

import DeviceApi from '@/api/device'
import { PageView } from '@/layouts'
import { mapActions, mapMutations } from 'vuex'
import DeviceGroupApi from '@/api/device-group'
const statusMap = {
  1: {
    status: 'processing',
    text: '正常',
  },
  3: {
    status: 'error',
    text: '已过期',
  },
}

export default {
  name: 'DeviceList',
  components: {
    PageView,
    STable,
    RenewalModal,
    RechargeModal,
    DatabaseModal,
    DbImportModal,
    DbInitModal,
    DbInitModalSuper,
    DeleteModal,
    PayModal,
    WarrantModal,
    DemoVideoAlert,
    GroupModal,
    SetDeviceGroupModal,
    DataTransferModal,
    KeyInput
  },
  data() {
    return {
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '客户端ID',
          // dataIndex: 'id',
          width: '150px',
          scopedSlots: { customRender: 'id' },
        },
        {
          title: '头像',
          scopedSlots: { customRender: 'avatar' },
          width: '80px',
        },
        {
          title: '微信信息',
          width: '150px',
          scopedSlots: { customRender: 'nickname' },
        },
        // {
        //   title: '终端IP 端口',
        //   scopedSlots: { customRender: 'ip' },
        // },
        {
          title: '终端',
          width: '150px',
          scopedSlots: { customRender: 'port' },
        },
        // {
        //   title: '微信ID',
        //   scopedSlots: { customRender: 'wx_id' },
        // },
        // {
        //   title: '余额',
        //   scopedSlots: { customRender: 'credit' },
        //   dataIndex: 'credit',
        //   width: '120px',
        //   sorter: true
        // },
        {
          title: '到期时间',
          scopedSlots: { customRender: 'time' },
          dataIndex: 'time',
          width: '200px',
          sorter: true,
        },
        {
          title: '客户端版本',
          width: '150px',
          scopedSlots: { customRender: 'edition_info.current_edition' },
          dataIndex: 'edition_info.current_edition'
        },
        {
          title: '数据库状态',
          width: '150px',
          scopedSlots: { customRender: 'db_status' },
        },
        {
          title: '分组名称',
          width: '150px',
          scopedSlots: { customRender: 'group_name' },
        },
        {
          title: '机器人状态',
          width: '150px',
          dataIndex: 'is_online',
          scopedSlots: { customRender: 'is_online' },
        },
        {
          title: '操作',
          width: '180px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      // 机器人状态查询
      robitStatusList: [
        { label: '软件在线', value: '1' },
        { label: '微信离线', value: '2' },
        { label: '软件离线', value: '3' },
        { label: '需要更新', value: '4' },
        { label: '需要续费', value: '5' },
      ],
      allRobot: 0, // 全部机器人
      offLine_robot: 0, // 离线机器人数量
      onLine_robot: 0, // 在线机器人数量
      need_renew: 0, // 需要续费机器人数量
      wx_offLine_robot: 0, // 微信离线
      need_update_robot: 0, // 需要更新
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return DeviceApi.getList(Object.assign(parameter, this.queryParam)).then(res=>{
          // console.log('res', res.dataObj)
          this.need_renew = res.dataObj.need_renew
          this.offLine_robot = res.dataObj.offLine_robot
          this.onLine_robot = res.dataObj.onLine_robot
          this.wx_offLine_robot = res.dataObj.wx_offLine_robot
          this.need_update_robot = res.dataObj.need_update_robot
          this.allRobot = res.dataObj.count
          return res
        })
      },
      selectedRowKeys: [],
      selectedRows: [],
      options: {
        alert: {
          show: true,
          clear: () => {
            this.selectedRowKeys = []
          },
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange,
        },
      },
      groupDataSource: [],
      setRemarkFlag: true,
    }
  },
  filters: {
    statusFilter(expire_time) {
      const curTimestamp = new Date().getTime()
      let type
      if (expire_time * 1000 > curTimestamp) {
        type = 1
      } else {
        type = 3
      }
      return statusMap[type].text
    },
    statusTypeFilter(expire_time) {
      const curTimestamp = new Date().getTime()
      let type
      if (expire_time * 1000 > curTimestamp) {
        type = 1
      } else {
        type = 3
      }
      return statusMap[type].status
    },
  },
  computed: {
    is_customized() {
      const is_customized = this.$store.state.user.info.operate_info.is_customized
      const is_custom_cash = this.$store.state.brand.is_custom_cash
      if (is_customized == 1 || is_custom_cash) {
        return true
      } else {
        return false
      }
    },
    independent() {
      return this.$store.state.brand.independent
    },
    is_database() {
      return !this.$store.state.brand.extend.includes('UseDataBase')
    },
  },
  created() {
    this.getGroupData()
  },
  methods: {
    ...mapActions(['demoSetVideo']),

    // 配置
    handleSettingItem(id) {
      this.$router.push({ path: `/device/setting/${id}` })
    },

    // 续期
    handleRenewal(id) {
      return
      this.$refs.renewalModal.show(id)
    },

    // 充值（已注掉）
    handleRecharge(id) {
      this.$refs.rechargeModal.show(id)
    },

    // 数据库设置（已注掉）
    handleDatabase(id) {
      this.$refs.databaseModal.show(id)
    },

    // 旧数据导入（已注掉）
    handleDbImport(id) {
      this.$refs.dbImportModal.show(id)
    },

    // 数据迁移
    handleDataTransfer(id) {
      this.$refs.dataTransfer.show(id)
    },

    // 创建数据库
    handleDbInit(id) {
      if (!this.is_database) {
        this.$refs.dbInitModalSuper.show(id)
      } else {
        this.$refs.dbInitModal.show(id)
      }
    },

    // 删除
    handleDeleteItem(id) {
      this.$refs.deleteModal.show(id)
    },

    // 这个文件没用到
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: true,
            clear: () => {
              this.selectedRowKeys = []
            },
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange,
          },
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null,
        }
        this.optionAlertShow = false
      }
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    // 设置分组
    handleSetDeviceGroup() {
      const sub_ids = this.selectedRows.map((item) => {
        return item.id
      })
      this.$refs.setDeviceGroupModal.show({ sub_ids })
    },

    getGroupData() {
      DeviceGroupApi.getList(
        Object.assign({
          pageSize: 200,
        })
      ).then((res) => {
        this.groupDataSource = res.data
      })
    },

    // 修改备注
    addRemark(record) {
      this.$refs.keyInput.show(record)
    },

    refresh() {
      this.$refs.table.refresh(true)
    },

  },
}
</script>

<style lang="less" scoped>
// /deep/ .ant-badge-status-dot{
//     width: 10px;
//     height: 10px;
// }
.black {
  color: #f5222d;
}

.robitStatusClass {
  text-align: center;
  position: relative;
  top: -6px;
}
</style>
